import React, { useState } from 'react';
import styles from "./apiGroupDescriptor.module.scss";
import { DropdownIcon } from '../../../assets/icon/IconCollection';
import { DropUpIcon } from '../../../assets/icon/IconCollection';
import { apiGroupDescriptions } from '../../../api/apiGroupDescriptions';

interface ApiGroupDescriptorProps {
  title: string;
  productName: string;
  type: 'API' | 'Webhook';
}

const ApiGroupDescriptor: React.FC<ApiGroupDescriptorProps> = (props) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleDropdownChange = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className={styles.ApiGroupHeader}>
      <div className={styles.ApiGroupTitleAndDropdown}>
        <div className={styles.title}>{props.title}</div>
        <div className={styles.versionDropdownWrapper}>
          <select
            name=""
            id=""
            className={styles.versionDropdown}
            onClick={handleDropdownChange}
          >
            <option value="">{props.productName === 'SafeSend Returns' || props.productName === 'Authentication'? 'v2' : 'v1'}</option>
          </select>
          <div className={styles.dropdownIcon}>
            {isOpen ? <DropUpIcon /> : <DropdownIcon />}
          </div>
        </div>
      </div>
      <div>
        {props.type === 'API' ? apiGroupDescriptions.API.find((item) => item.apiGroup === props.title)?.apiGroupDescription : apiGroupDescriptions.Webhook.find((item) => item.productName === props.title)?.description}
      </div>
    </div>
  );
};

export default ApiGroupDescriptor;
